import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

const translations = {
  RU: {
    // Header
    services: "Услуги",
    documents: "Нормативные документы",
    news: "Новости и статьи",
    faq: "Часто задаваемые вопросы",
    about: "О компании",
    contacts: "Контакты",
    calculateCost: "Рассчитать стоимость",
    consultation: "Консультация",
    freeConsultation: "Консультация бесплатно",
    
    // Hero
    heroTitle: "Качественное, быстрое и легальное оформление разрешительной документации",
    heroSubtitle: "Профессиональными сотрудниками самой надежной консалтинговой компании без отказов и задержек",
    getConsultation: "Получить консультацию",
    learnMore: "Узнать подробности",
    ourAdvantages: "Наши преимущества",
    workWithAuthentic: "Работаем только с подлинными документами",
    legalProtection: "Полная юридическая защита и гарантии",
    
    // Hero features
    technicalAnalysis: "Анализ технической документации",
    instantLaunch: "Моментальный запуск",
    turnkeyProcessing: "Оформление «под ключ»",
    staffTranslator: "Свой штатный переводчик",
    
    // Services
    ourServices: "Наши услуги",
    servicesDescription: "Оказываем более 20 видов услуг по оформлению разрешительной документации. Работаем быстро, качественно и в рамках закона.",
    allServices: "Все услуги",
    nonTariffRegulation: "Нетарифное регулирование",
    trademark: "Товарный знак",
    markingAndCZ: "Маркировка и ЧЗ",
    orderDocument: "Заказать документ",
    learnMoreBtn: "Подробнее",
    notFoundService: "Не нашли нужный документ?",
    notFoundDescription: "Мы оформляем более 20 видов разрешительных документов. Свяжитесь с нами для консультации по вашему конкретному случаю.",
    
    // Process
    collaborationSteps: "Этапы сотрудничества",
    processDescription: "От вас — техническое описание, а все остальное сделаем мы. Простой и понятный процесс работы.",
    
    // Advantages
    reasonsToChoose: "10 причин обратиться за помощью именно к нам",
    advantagesDescription: "Решаем задачи клиентов максимально эффективно благодаря опыту и профессионализму",
    trustRelations: "Доверительные отношения с государственными органами",
    trustDescription: "За годы плотной работы мы наладили доверительные отношения с согласующими органами и узнали все их негласные требования, благодаря чему можем помочь в решении самых сложных вопросов.",
    
    // Partners
    ourPartners: "Наши партнеры",
    partnersDescription: "Мы гордимся сотрудничеством с крупными российскими и международными компаниями",
    satisfiedClients: "Довольных клиентов",
    documentTypes: "Типов документов",
    successfulApplications: "Успешных заявок",
    averageResponseTime: "Среднее время ответа",
    
    // Security
    beCareful: "Будьте осторожны с недобросовестными компаниями",
    securityWarning: "На рынке есть много компаний-однодневок, предлагающих поддельные документы. Это может привести к административным штрафам и уголовной ответственности.",
    workWithAuthentic: "Мы работаем только с подлинными документами и предоставляем полные гарантии",
    
    // Contact
    contactUs: "Свяжитесь с нами",
    contactDescription: "Получите бесплатную консультацию и расчет стоимости услуг. Ответим на все ваши вопросы в течение часа.",
    contactInfo: "Контактная информация",
    calculateServiceCost: "Рассчитаем стоимость услуги",
    yourName: "Ваше имя",
    email: "E-mail",
    phone: "Телефон",
    cityDelivery: "Город для доставки",
    documentsNeeded: "Перечислите интересующие вас документы",
    sendRequest: "Отправить запрос",
    sendFile: "Отправить файл с описанием товара",
    clickToUpload: "Нажмите для загрузки файла",
    maxSize: "Максимальный размер 6 МБ. Форматы: doc, pdf, txt, xlsx",
    agreeToProcessing: "Нажимая на кнопку «Отправить запрос», я соглашаюсь на обработку персональных данных",
    getRightNow: "Получите прямо сейчас:",
    freeConsultationItem: "Бесплатную консультацию",
    documentAnalysis: "Анализ документации",
    costCalculation: "Расчет стоимости",
    actionPlan: "План действий",
    
    // Footer
    customsConsulting: "Таможенный консалтинг и оформление разрешительной документации",
    phone: "Телефон",
    email: "Email",
    address: "Адрес",
    workHours: "Режим работы",
    aroundClock: "Круглосуточно",
    replyInHour: "Ответим в течение часа",
    centralOffice: "Москва, Центральный офис",
    workTime: "Пн-Пт: 9:00-19:00",
    consultations247: "Консультации 24/7",
    quickLinks: "Быстрые ссылки",
    stayInformed: "Будьте в курсе",
    subscribeUpdates: "Подписывайтесь на обновления законодательства и новости компании",
    freeConsultationFooter: "Бесплатная консультация",
    getExpertAdvice: "Получите экспертный совет прямо сейчас",
    contactUsFooter: "Связаться с нами",
    allRightsReserved: "Все права защищены",
    yourEmail: "Ваш email",
    
    // Service Page translations
    serviceNotFound: "Услуга не найдена",
    serviceNotFoundDesc: "Запрошенная услуга не существует или была перемещена.",
    backToHome: "Вернуться на главную",
    home: "Главная",
    timeframe: "Срок",
    serviceDescription: "Описание услуги",
    requiredDocuments: "Необходимые документы",
    processingSteps: "Процесс оформления",
    workingAdvantages: "Преимущества работы с нами",
    orderService: "Заказать услугу",
    sendApplication: "Отправить заявку",
    comment: "Комментарий",
    freeConsultationDesc: "Консультация бесплатная. Ответим на все вопросы в течение часа.",
    emailCopied: "Email скопирован!",
    phoneCopied: "Телефон скопирован!",
    languageChanged: "Язык изменен на Русский",
    reloadForChanges: "Перезагрузите страницу для применения изменений",
    error: "Ошибка",
    failedToCopyEmail: "Не удалось скопировать email",
    failedToCopyPhone: "Не удалось скопировать телефон"
  },
  
  EN: {
    // Header
    services: "Services",
    documents: "Regulatory Documents",
    news: "News & Articles",
    faq: "FAQ",
    about: "About Us",
    contacts: "Contacts",
    calculateCost: "Calculate Cost",
    consultation: "Consultation",
    freeConsultation: "Free Consultation",
    
    // Hero
    heroTitle: "High-quality, fast and legal processing of regulatory documentation",
    heroSubtitle: "By professional employees of the most reliable consulting company without refusals and delays",
    getConsultation: "Get Consultation",
    learnMore: "Learn More",
    ourAdvantages: "Our Advantages",
    workWithAuthentic: "We work only with authentic documents",
    legalProtection: "Full legal protection and guarantees",
    
    // Hero features
    technicalAnalysis: "Technical documentation analysis",
    instantLaunch: "Instant launch",
    turnkeyProcessing: "Turnkey processing",
    staffTranslator: "In-house translator",
    
    // Services
    ourServices: "Our Services",
    servicesDescription: "We provide more than 20 types of services for processing regulatory documentation. We work quickly, efficiently and within the law.",
    allServices: "All Services",
    nonTariffRegulation: "Non-tariff Regulation",
    trademark: "Trademark",
    markingAndCZ: "Marking & CZ",
    orderDocument: "Order Document",
    learnMoreBtn: "Learn More",
    notFoundService: "Didn't find the document you need?",
    notFoundDescription: "We process more than 20 types of regulatory documents. Contact us for consultation on your specific case.",
    
    // Process
    collaborationSteps: "Collaboration Steps",
    processDescription: "From you - technical description, and we will do everything else. Simple and clear work process.",
    
    // Advantages
    reasonsToChoose: "10 reasons to turn to us for help",
    advantagesDescription: "We solve client problems as efficiently as possible thanks to experience and professionalism",
    trustRelations: "Trusted relationships with government agencies",
    trustDescription: "Over the years of close work, we have established trusting relationships with regulatory authorities and learned all their unspoken requirements, thanks to which we can help solve the most complex issues.",
    
    // Partners
    ourPartners: "Our Partners",
    partnersDescription: "We are proud to cooperate with major Russian and international companies",
    satisfiedClients: "Satisfied clients",
    documentTypes: "Document types",
    successfulApplications: "Successful applications",
    averageResponseTime: "Average response time",
    
    // Security
    beCareful: "Be careful with unscrupulous companies",
    securityWarning: "There are many shell companies on the market offering fake documents. This can lead to administrative fines and criminal liability.",
    workWithAuthentic: "We work only with authentic documents and provide full guarantees",
    
    // Contact
    contactUs: "Contact Us",
    contactDescription: "Get a free consultation and service cost calculation. We will answer all your questions within an hour.",
    contactInfo: "Contact Information",
    calculateServiceCost: "Calculate Service Cost",
    yourName: "Your name",
    email: "E-mail",
    phone: "Phone",
    cityDelivery: "City for delivery",
    documentsNeeded: "List the documents you are interested in",
    sendRequest: "Send Request",
    sendFile: "Send file with product description",
    clickToUpload: "Click to upload file",
    maxSize: "Maximum size 6 MB. Formats: doc, pdf, txt, xlsx",
    agreeToProcessing: "By clicking the \"Send Request\" button, I agree to the processing of personal data",
    getRightNow: "Get right now:",
    freeConsultationItem: "Free consultation",
    documentAnalysis: "Document analysis",
    costCalculation: "Cost calculation",
    actionPlan: "Action plan",
    
    // Footer
    customsConsulting: "Customs consulting and regulatory documentation processing",
    phone: "Phone",
    email: "Email",
    address: "Address",
    workHours: "Working Hours",
    aroundClock: "Around the clock",
    replyInHour: "Reply within an hour",
    centralOffice: "Moscow, Central Office",
    workTime: "Mon-Fri: 9:00-19:00",
    consultations247: "Consultations 24/7",
    quickLinks: "Quick Links",
    stayInformed: "Stay Informed",
    subscribeUpdates: "Subscribe to legislation updates and company news",
    freeConsultationFooter: "Free Consultation",
    getExpertAdvice: "Get expert advice right now",
    contactUsFooter: "Contact Us",
    allRightsReserved: "All rights reserved",
    yourEmail: "Your email",
    
    // Service Page translations
    serviceNotFound: "Service Not Found",
    serviceNotFoundDesc: "The requested service does not exist or has been moved.",
    backToHome: "Back to Home",
    home: "Home",
    timeframe: "Timeframe",
    serviceDescription: "Service Description",
    requiredDocuments: "Required Documents",
    processingSteps: "Processing Steps",
    workingAdvantages: "Advantages of Working with Us",
    orderService: "Order Service",
    sendApplication: "Send Application",
    comment: "Comment",
    freeConsultationDesc: "Consultation is free. We will answer all questions within an hour.",
    
    // Toast messages
    emailCopied: "Email copied!",
    phoneCopied: "Phone copied!",
    languageChanged: "Language changed to English",
    reloadForChanges: "Reload the page to apply changes",
    error: "Error",
    failedToCopyEmail: "Failed to copy email",
    failedToCopyPhone: "Failed to copy phone"
  }
};

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState('RU');

  const changeLanguage = (lang) => {
    setCurrentLanguage(lang);
  };

  const t = (key) => {
    return translations[currentLanguage][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ currentLanguage, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};